import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export type FileUploadUniDriver = BaseUniDriver;

export const fileUploadDriverFactory = (
  base: UniDriver,
): FileUploadUniDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
